import { defineComponent as _defineComponent } from 'vue'
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseIcon,
  BaseText,
  ButtonPrimary,
  Heading
} from '@warrenbrasil/nebraska-web';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import animationData from '@/assets/imgs/icons/animated_logo.json';
import lottie from 'lottie-web';
import { useRoute } from 'vue-router/composables';
import { Portal } from '../../components/Portal';

export default /*#__PURE__*/_defineComponent({
  __name: 'LandingApp',
  setup(__props) {

const animation = ref<Element | null>(null);
const userAgent = navigator.userAgent;
const scrollPosition = ref(0);
const scrollElement = ref<HTMLElement | null>(null);
const scrollContainer = ref<Element | null>(null);
const route = useRoute();

function scrollRight() {
  if (scrollContainer.value) {
    const container = scrollContainer.value;
    const scrollValue = 450;

    container.scrollBy({
      left: scrollValue,
      behavior: 'smooth'
    });
  }
}

const headingText = computed(() => {
  return cameFromSignup.value
    ? 'Baixe o App para abrir a sua conta'
    : 'Baixe o App para acessar a sua conta.';
});

const cameFromSignup = computed(() => {
  return route.query.from === 'signup';
});

function loadLogoAnimation() {
  animation.value &&
    lottie.loadAnimation({
      container: animation.value,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData
    });
}

onMounted(() => {
  loadLogoAnimation();
  if (scrollContainer.value) {
    const container = scrollContainer.value;

    const handleScroll = () => {
      scrollPosition.value =
        container.scrollLeft / (container.scrollWidth - container.clientWidth);

      if (scrollElement.value) {
        const initialLeft = 24;
        const finalLeft = 0;
        const maxOpacity = 1;
        const scrollThreshold = 0.03;
        const opacity = maxOpacity - scrollPosition.value / scrollThreshold;
        const left =
          initialLeft -
          (initialLeft - finalLeft) * (scrollPosition.value / scrollThreshold);

        scrollElement.value.style.opacity = opacity.toString();
        scrollElement.value.style.left = `${left}px`;
      }
    };

    container.addEventListener('scroll', handleScroll);

    onUnmounted(() => {
      container.removeEventListener('scroll', handleScroll);
    });
  }
});
const imgPath = computed(() => {
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'ios';
  } else {
    return 'android';
  }
});
const storeHref = computed(() => {
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'https://apps.apple.com/br/app/warren-investimentos/id1114394063';
  } else {
    return route.query?.advisor
      ? `https://play.google.com/store/apps/details?id=com.oiwarren.oiwarren&referrer=utm_source${encodeURIComponent(
          `=${route.query?.advisor}`
        )}`
      : 'https://play.google.com/store/apps/details?id=com.oiwarren.oiwarren';
  }
});
const storeName = computed(() => {
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'App';
  } else {
    return 'Play';
  }
});

return { __sfc: true,animation, userAgent, scrollPosition, scrollElement, scrollContainer, route, scrollRight, headingText, cameFromSignup, loadLogoAnimation, imgPath, storeHref, storeName, NebraskaColors, BaseIcon, BaseText, ButtonPrimary, Heading, Portal }
}

})